import { render, staticRenderFns } from "./EditEducationHistory.vue?vue&type=template&id=13f89fe9&"
import script from "./EditEducationHistory.vue?vue&type=script&lang=js&"
export * from "./EditEducationHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports